// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-wgQ","comment":"styles_comment__2cbXx"};